import axios from 'axios';
import { Message } from 'element-ui';

export async function postDownload(url, params, fileName, truncatedWarningText) {
    const res = await axios.post(url, params, { responseType: 'blob' });
    // 错误拦截
    if (res.status !== 200) {
        try {
            const text = await new Response(res.data).text();
            const err = JSON.parse(text);
            throw new Error(err.msg || err.message || "导出失败");
        } catch (e) {
            throw new Error(e instanceof SyntaxError ? "导出失败(非JSON错误)" : e.message);
        }
    }

    var contentType = res.headers && res.headers['content-type'];
    if (contentType.includes('application/json') || contentType.includes('text/')) {
        const text = await new Response(res.data).text();
        try {
            const err = JSON.parse(text);
            throw new Error(err.msg || err.message || "导出失败");
        } catch (e) {
            if (e.message) throw e; // 如果上面已经抛出了业务错误，直接抛出
            throw new Error(`服务端返回非文件内容: ${text.substring(0, 100)}`);
        }
    }

    if (res.headers['x-export-truncated'] === 'true') {
        const original = res.headers['x-export-original-size'];
        const exported = res.headers['x-exported-size'];
        const msg = truncatedWarningText
            ? truncatedWarningText.replace('{exported}', exported).replace('{original}', original)
            : `数据量过大，仅导出前 ${exported} 条（共 ${original} 条）`;
        Message.warning(msg);
    }

    // 直接触发下载
    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob([res.data]));
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
}


// WEBPACK FOOTER //
// ./src/utils/download.js